import { ModalService } from '@capsicum/common-web';
import { type UseExportAndCloseAccountDrawersProps } from '@capsicum/features/account/shared';

import { ExportAndCloseAccountErrorDrawer, ExportAndCloseAccountTransferDrawer } from '../ui';

/**
 * This hook was part of the "Export Private Key and Delete Account" web user story.
 * It returns two callbacks which deliver the Error modal and TransferFirstWarningModal.
 * @param {() => void} onPrimaryButtonActivate the callback to execute when the primary button is activated
 * @param {() => void} onSecondaryButtonActivate the callback to execute when the secondary button is activated
 * @returns {UseExportAndCloseAccountDrawersProps} two callbacks
 */
export const useExportAndCloseAccountDrawers = ({
	onPrimaryButtonActivate,
	onSecondaryButtonActivate
}: UseExportAndCloseAccountDrawersProps) => {
	const openErrorDrawer = () => {
		ModalService.addModal({
			detached: false,
			renderComponent: ({ close }) => <ExportAndCloseAccountErrorDrawer closeModal={close} />
		});
	};

	const openTransferFirstWarningModal = () =>
		ModalService.addModal({
			isClosable: false,
			renderComponent: ({ close }) => (
				<ExportAndCloseAccountTransferDrawer
					onClickToWallet={() => {
						close();
						onPrimaryButtonActivate();
					}}
					onContinue={() => {
						close();
						onSecondaryButtonActivate();
					}}
				/>
			)
		});

	return {
		openErrorDrawer,
		openTransferFirstWarningModal
	};
};
